// src/pages/NotFound.tsx
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-coffee-100">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <Coffee className="h-16 w-16 text-coffee-600" />
        </div>
        <h1 className="text-4xl md:text-5xl font-serif font-medium text-coffee-800 mb-4">404 - Page Not Found</h1>
        <p className="text-lg text-coffee-600 mb-8 max-w-md mx-auto">
          Oops! Looks like this page got lost in the coffee grounds. Let’s get you back to the brew.
        </p>
        <Link to="/" className="btn-primary flex items-center gap-2 mx-auto w-fit">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;